import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Container,
  Paper,
  Title,
  Text,
  TextInput,
  PasswordInput,
  Button,
  Stack,
  Alert,
  Center,
  Box
} from '@mantine/core';
import { IconAlertCircle, IconCar } from '@tabler/icons-react';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      if (err.response) {
        setError(err.response.data?.detail || `Errore server: ${err.response.status}`);
      } else if (err.request) {
        setError('Impossibile contattare il server. Verifica la connessione.');
      } else {
        setError('Errore imprevisto. Riprova.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f1f5f9'
      }}
    >
      <Container size={420}>
        <Paper radius="md" p="xl" shadow="md" withBorder>
          <Center mb="lg">
            <Box
              style={{
                width: 60,
                height: 60,
                borderRadius: '50%',
                backgroundColor: 'rgb(32, 83, 87)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <IconCar size={32} color="white" />
            </Box>
          </Center>
          
          <Title order={2} ta="center" c="rgb(32, 83, 87)" mb="xl">
            Moovo Rent
          </Title>

          {error && (
            <Alert 
              icon={<IconAlertCircle size={16} />} 
              color="red" 
              mb="md"
              variant="light"
            >
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <Stack>
              <TextInput
                label="Email"
                placeholder="nome@esempio.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <PasswordInput
                label="Password"
                placeholder="La tua password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <Button 
                type="submit" 
                fullWidth 
                mt="md"
                loading={loading}
                color="teal"
                styles={{
                  root: {
                    backgroundColor: 'rgb(32, 83, 87)',
                    '&:hover': {
                      backgroundColor: 'rgb(25, 65, 68)'
                    }
                  }
                }}
              >
                Accedi
              </Button>
            </Stack>
          </form>
        </Paper>
      </Container>
    </Box>
  );
}

export default Login;
